export default "__VITE_ASSET__MTzw9zuH__"